<div class="contacts">

    <h2>
        Франшиза
    </h2>
    <div class="shop-info" [innerHTML]="franchise">
    </div>
</div>